import * as React from 'react';
import { BaseFieldProps, Field } from 'redux-form';
import { InputView, Props as InputViewProps } from '../InputView';

export type Props = BaseFieldProps & InputViewProps;

export const Input: React.FC<Props> = (props) => <Field component={InputView} {...props} />;
